import {
  sharedStarIcon,
  sharedProgramIntro,
  getSharedGalleryImages,
  sharedSkillCommunicationIcon as skillHeritage,
  sharedSkillTimeManagementIcon as womenSkillTimeManagement,
  sharedSkillConstitutionalIcon as skillConstitutional,
  sharedSkillNationBuildingIcon as skillNationGov,
  videoThumbnail,
  founderImage,
  midPageBanner,
  impactBanner,
  volunteerBanner,
} from '../assets/index'
import skillFestival from '../assets/icons/programs/cultural/skill-festival.png'
import skillWorkshops from '../assets/icons/programs/cultural/skill-workshops.png'
import skillArts from '../assets/icons/programs/cultural/skill-arts.png'
import skillAwareness from '../assets/icons/programs/cultural/skill-awareness.png'
import womenSkillLeadership from '../assets/icons/programs/women/skill-leadership.png'
import womenSkillCommunication from '../assets/icons/programs/women/skill-communication.png'
import womenSkillDecisionMaking from '../assets/icons/programs/women/skill-decision-making.png'
import womenSkillSelfConfidence from '../assets/icons/programs/women/skill-self-confidence.png'
import womenSkillTeamwork from '../assets/icons/programs/women/skill-teamwork.png'
import skillCivic from '../assets/icons/programs/governance/skill-civic.png'
import skillDemocratic from '../assets/icons/programs/governance/skill-democratic.png'
import skillTransparency from '../assets/icons/programs/governance/skill-transparency.png'
import skillCommunity from '../assets/icons/programs/governance/skill-community.png'
import nationSkillLeadership from '../assets/icons/programs/nation-building/skill-leadership.png'
import nationSkillCommunity from '../assets/icons/programs/nation-building/skill-community.png'
import nationSkillCivic from '../assets/icons/programs/nation-building/skill-civic.png'
import nationSkillSocial from '../assets/icons/programs/nation-building/skill-social.png'
import nationSkillEnvironment from '../assets/icons/programs/nation-building/skill-environment.png'
import nationSkillUnity from '../assets/icons/programs/nation-building/skill-unity.png'

const images = [videoThumbnail, founderImage, midPageBanner, impactBanner, volunteerBanner]

export const programs = {
  'leadership-development': {
    title: 'Leadership Development',
    subtitle:
      'Comprehensive training programs that build essential leadership skills, decision-making abilities, and strategic thinking in young individuals through workshops, seminars, and hands-on experiences.',
    heroImage: videoThumbnail,
    intro:
      'Leadership Development at Disha Foundation is designed to help young individuals unlock their potential, strengthen their character, and develop the confidence to lead with purpose. Through workshops, mentorship, team activities, and real-world experiences, participants gain practical leadership skills that prepare them for personal and professional success.',
    whyTitle: 'Why Leadership Matters ?',
    whyItems: [
      'Build Self Confidence',
      'Improve Communication Skills',
      'Enhance Decision Making',
      'Strengthen Teamwork',
      'Develop Problem Solving Abilities',
      'Foster Social Responsibility',
    ],
    skillsTitle: 'Key Skills We Develop',
    skills: [
      { title: 'Communication Skills', description: 'Express ideas clearly and confidently.' },
      { title: 'Team Building', description: 'Learn collaboration, trust, and teamwork.' },
      { title: 'Critical Thinking', description: 'Analyze situations and make informed decisions.' },
      { title: 'Public Speaking', description: 'Present with confidence in any setting.' },
      { title: 'Strategic Planning', description: 'Set goals and create actionable plans.' },
      { title: 'Emotional Intelligence', description: 'Understand and manage emotions effectively.' },
    ],
    cta: 'Join The Program',
  },
  'cultural-initiatives': {
    title: 'Cultural Initiatives',
    subtitle:
      "Programs celebrating India's rich cultural heritage through festivals, traditional arts, music, dance, and cultural exchange activities that strengthen national identity and pride.",
    cta: 'Join The Program',
    ctaLink: '/contact',
    introImage: sharedProgramIntro,
    introImageCrop: 'figma',
    introParagraphs: [
      'Disha Foundation believes that culture is the foundation of a strong and united society. Our cultural initiatives aim to educate, inspire, and engage youth in preserving traditions, understanding heritage, and embracing values that contribute to personal growth and nation-building.',
      "Through events, workshops, festivals, and awareness programs, we encourage young individuals to develop a deeper appreciation for India's cultural legacy.",
    ],
    whyTitle: 'Why Cultural Awareness Matters ?',
    whyItems: [
      'Protects and passes cultural heritage to future generations.',
      'Helps youth understand their roots and cultural values.',
      'Strengthens social harmony and national integration.',
      'Inspires individuals to contribute positively to society.',
    ],
    useProgramWhyLayout: true,
    whyStarIcon: sharedStarIcon,
    skillsTitle: 'Key Skills We Develop',
    skillsLayout: 'three-two',
    skills: [
      {
        title: 'Cultural Heritage Programs',
        description:
          "Educational sessions that explore India's traditions, history, and cultural contributions.",
        iconSrc: skillHeritage,
        iconBgColor: 'rgba(183,7,7,0.12)',
      },
      {
        title: 'Festival Celebrations',
        description:
          'Organizing cultural festivals that bring communities together and celebrate diversity.',
        iconSrc: skillFestival,
        iconBgColor: 'rgba(183,142,7,0.12)',
      },
      {
        title: 'Value-Based Workshops',
        description:
          'Interactive programs focused on ethics, character building, and social responsibility.',
        iconSrc: skillWorkshops,
        iconBgColor: 'rgba(115,183,7,0.12)',
      },
      {
        title: 'Traditional Arts & Activities',
        description:
          'Promoting folk arts, music, literature, and cultural expressions among youth.',
        iconSrc: skillArts,
        iconBgColor: 'rgba(7,183,183,0.12)',
      },
      {
        title: 'Awareness Campaigns',
        description: 'Initiatives that encourage cultural preservation and national unity.',
        iconSrc: skillAwareness,
        iconBgColor: 'rgba(7,30,183,0.12)',
      },
    ],
    statsTitle: 'Connecting Youth With Heritage',
    stats: [
      { value: '5000+', label: 'Youth Engaged' },
      { value: '100+', label: 'Cultural Programs Conducted' },
      { value: '50+', label: 'Community Events Organized' },
      { value: '20+', label: 'Heritage Awareness Campaigns' },
    ],
    showOtherInitiatives: true,
    excludeFromInitiatives: '/programs/cultural-initiatives',
    galleryTitle: 'Gallery',
    galleryImages: getSharedGalleryImages('Cultural Initiatives', [
      'Cultural program community gathering',
      'Cultural program youth session',
      'Cultural program workshop',
      'Cultural program panel discussion',
      'Cultural program meeting',
    ]),
    showExperiences: true,
  },
  'women-empowerment': {
    title: 'Women Empowerment',
    subtitle:
      "Dedicated initiatives supporting women's education, skill development, entrepreneurship, and leadership roles to create equal opportunities and foster gender equality in society.",
    cta: 'Join The Program',
    ctaLink: '/contact',
    introImage: sharedProgramIntro,
    introImageCrop: 'figma',
    introParagraphs: [
      'At Disha Foundation, we believe empowered women are the foundation of strong families, thriving communities, and a progressive nation. Our women empowerment initiatives focus on education, leadership development, skill enhancement, health awareness, and personal growth, helping women realize their full potential and become agents of positive change.',
    ],
    missionTitle: 'Our Mission',
    mission:
      'At Disha Foundation, our mission is to empower women through education, leadership development, skill enhancement, and community engagement. We strive to create opportunities that build confidence, promote independence, and inspire women to become active contributors to society. By fostering personal growth, equal opportunities, and social awareness, we aim to nurture empowered women who can lead positive change within their families, communities, and the nation.',
    whyTitle: 'Why Women Empowerment Matters ?',
    whyItems: [
      'Encourages women to pursue opportunities and achieve their goals.',
      'Empowered women contribute to stronger families and communities.',
      'Creates opportunities for participation, leadership, and growth.',
      'Women play a vital role in shaping a better future for society.',
    ],
    useProgramWhyLayout: true,
    whyStarIcon: sharedStarIcon,
    skillsTitle: 'Key Skills We Develop',
    skillsLayout: 'grid',
    skills: [
      {
        title: 'Leadership',
        description: 'Building confidence and the ability to inspire others.',
        iconSrc: womenSkillLeadership,
        iconBgColor: 'rgba(183,7,7,0.12)',
      },
      {
        title: 'Communication',
        description: 'Enhancing speaking, listening, and interpersonal skills.',
        iconSrc: womenSkillCommunication,
        iconBgColor: 'rgba(183,142,7,0.12)',
      },
      {
        title: 'Decision Making',
        description: 'Developing critical thinking and problem-solving abilities.',
        iconSrc: womenSkillDecisionMaking,
        iconBgColor: 'rgba(115,183,7,0.12)',
      },
      {
        title: 'Self Confidence',
        description: 'Encouraging personal growth and independence.',
        iconSrc: womenSkillSelfConfidence,
        iconBgColor: 'rgba(7,183,183,0.12)',
      },
      {
        title: 'Teamwork',
        description: 'Strengthening collaboration, trust, and leadership in groups.',
        iconSrc: womenSkillTeamwork,
        iconBgColor: 'rgba(7,30,183,0.12)',
      },
      {
        title: 'Time Management',
        description: 'Improving productivity, discipline, and goal achievement.',
        iconSrc: womenSkillTimeManagement,
        iconBgColor: 'rgba(183,7,171,0.12)',
      },
    ],
    statsTitle: 'Empowering Women Nationwide',
    stats: [
      { value: '3000+', label: 'Women Empowered' },
      { value: '100+', label: 'Training Programs' },
      { value: '50+', label: 'Community Initiatives' },
      { value: '500+', label: 'Active Participants' },
    ],
    showOtherInitiatives: true,
    excludeFromInitiatives: '/programs/women-empowerment',
    galleryTitle: 'Gallery',
    galleryImages: getSharedGalleryImages('Women Empowerment', [
      'Women empowerment program gathering',
      'Women leadership workshop',
      'Women empowerment community event',
      'Women empowerment speaker session',
      'Women empowerment group meeting',
    ]),
    showExperiences: true,
  },
  'good-governance-awareness': {
    title: 'Good Governance Awareness',
    subtitle:
      'Educational programs promoting transparency, accountability, civic responsibility, and active citizen participation in democratic processes and governance systems.',
    cta: 'Join The Program',
    ctaLink: '/contact',
    introImage: sharedProgramIntro,
    introImageCrop: 'figma',
    introParagraphs: [
      'Good Governance Awareness aims to educate and engage citizens, especially youth, about their rights, duties, and role in strengthening democracy. Through awareness programs, discussions, and community initiatives, we encourage active participation, transparency, accountability, and responsible citizenship.',
    ],
    missionTitle: 'Our Mission',
    mission:
      'To foster civic awareness, democratic participation, and ethical leadership by encouraging citizens to actively contribute to good governance and community development.',
    whyTitle: 'Why Good Governance\nAwareness Matters ?',
    whyItems: [
      'Strengthens democratic values',
      'Promotes informed decision-making',
      'Encourages responsible citizenship',
      'Builds trust between citizens and institutions',
      'Inspires positive social change',
    ],
    useProgramWhyLayout: true,
    whyStarIcon: sharedStarIcon,
    whyTitleMaxWidth: { md: 282, lg: 282 },
    skillsTitle: 'Key Skills We Develop',
    skillsLayout: 'grid',
    skills: [
      {
        title: 'Civic Responsibility',
        description: 'Encouraging citizens to understand and fulfill their social responsibilities.',
        iconSrc: skillCivic,
        iconBgColor: 'rgba(183,7,7,0.12)',
      },
      {
        title: 'Democratic Participation',
        description: 'Promoting active involvement in democratic processes and public affairs.',
        iconSrc: skillDemocratic,
        iconBgColor: 'rgba(183,142,7,0.12)',
      },
      {
        title: 'Transparency & Accountability',
        description: 'Creating awareness about ethical governance and responsible leadership.',
        iconSrc: skillTransparency,
        iconBgColor: 'rgba(115,183,7,0.12)',
      },
      {
        title: 'Community Engagement',
        description: 'Inspiring citizens to participate in local development and social initiatives.',
        iconSrc: skillCommunity,
        iconBgColor: 'rgba(7,183,183,0.12)',
      },
      {
        title: 'Constitutional Awareness',
        description: 'Educating youth about constitutional values, rights, and duties.',
        iconSrc: skillConstitutional,
        iconBgColor: 'rgba(7,30,183,0.12)',
      },
      {
        title: 'Nation Building',
        description: 'Encouraging collective efforts toward a stronger and more progressive nation.',
        iconSrc: skillNationGov,
        iconBgColor: 'rgba(183,7,171,0.12)',
      },
    ],
    statsTitle: 'Connecting Youth With Heritage',
    stats: [
      { value: '5000+', label: 'Citizens Reached' },
      { value: '100+', label: 'Awareness Programs' },
      { value: '50+', label: 'Community Initiatives' },
      { value: '1,000+', label: 'Youth Participants' },
    ],
    showOtherInitiatives: true,
    excludeFromInitiatives: '/programs/good-governance-awareness',
    galleryTitle: 'Gallery',
    galleryImages: getSharedGalleryImages('Good Governance Awareness', [
      'Good governance awareness program gathering',
      'Good governance awareness youth session',
      'Good governance awareness workshop',
      'Good governance awareness panel discussion',
      'Good governance awareness community meeting',
    ]),
    showExperiences: true,
  },
  'nation-building-activities': {
    title: 'Nation Building Activities',
    subtitle:
      "Community service projects, social awareness campaigns, environmental initiatives, and patriotic programs that contribute to India's development and national progress.",
    cta: 'Join The Program',
    ctaLink: '/contact',
    introImage: sharedProgramIntro,
    introImageCrop: 'figma',
    introParagraphs: [
      "Nation building begins with responsible citizens who are committed to serving society and contributing to the country's progress. Disha Foundation organizes various activities that encourage youth and communities to participate in social development, civic engagement, leadership programs, and service initiatives. Through these efforts, we aim to foster unity, responsibility, and a shared commitment to national welfare.",
    ],
    missionTitle: 'Our Mission',
    mission:
      'To inspire individuals, especially youth, to become active contributors to society by promoting leadership, civic responsibility, community service, and values-driven action that strengthens the nation.',
    whyTitle: 'Why Nation Building Matters ?',
    whyItems: [
      'Encourages individuals to actively contribute to society.',
      'Builds stronger and more connected communities.',
      'Brings people together for a common purpose.',
      'Creates lasting impact through collective action and service.',
    ],
    useProgramWhyLayout: true,
    whyStarIcon: sharedStarIcon,
    whyTitleMaxWidth: { md: 355, lg: 355 },
    skillsTitle: 'Key Skills We Develop',
    skillsLayout: 'grid',
    skills: [
      {
        title: 'Leadership Development',
        description: 'Preparing youth to become responsible leaders and changemakers.',
        iconSrc: nationSkillLeadership,
        iconBgColor: 'rgba(183,7,7,0.12)',
      },
      {
        title: 'Community Service',
        description: 'Encouraging selfless service through impactful social initiatives.',
        iconSrc: nationSkillCommunity,
        iconBgColor: 'rgba(183,142,7,0.12)',
      },
      {
        title: 'Civic Awareness',
        description: 'Promoting responsible citizenship and democratic participation.',
        iconSrc: nationSkillCivic,
        iconBgColor: 'rgba(115,183,7,0.12)',
      },
      {
        title: 'Social Responsibility',
        description: 'Inspiring individuals to contribute positively to society.',
        iconSrc: nationSkillSocial,
        iconBgColor: 'rgba(7,183,183,0.12)',
      },
      {
        title: 'Environmental Stewardship',
        description: 'Supporting initiatives that protect and improve our environment.',
        iconSrc: nationSkillEnvironment,
        iconBgColor: 'rgba(7,30,183,0.12)',
      },
      {
        title: 'National Unity',
        description: 'Strengthening social harmony, cultural pride, and collective progress.',
        iconSrc: nationSkillUnity,
        iconBgColor: 'rgba(183,7,171,0.12)',
      },
    ],
    statsTitle: 'Connecting Youth With Heritage',
    stats: [
      { value: '10,000+', label: 'Individuals Engaged' },
      { value: '200+', label: 'Community Activities Conducted' },
      { value: '1,000+', label: 'Active Volunteers' },
      { value: '100+', label: 'Awareness Campaigns' },
    ],
    showOtherInitiatives: true,
    excludeFromInitiatives: '/programs/nation-building-activities',
    galleryTitle: 'Gallery',
    galleryImages: getSharedGalleryImages('Nation Building Activities', [
      'Nation building community gathering',
      'Nation building youth session',
      'Nation building workshop',
      'Nation building panel discussion',
      'Nation building community meeting',
    ]),
    showExperiences: true,
  },
}

export const dimensions = {
  'student-welfare': {
    title: 'Student Welfare',
    subtitle: 'Supporting students through guidance, mentorship, and growth opportunities for holistic development.',
    heroImage: images[0],
    intro: 'Student Welfare programs at Disha Foundation provide comprehensive support for students through academic guidance, mentorship, career counseling, and personal development initiatives.',
    whyTitle: 'Why Student Welfare Matters ?',
    whyItems: [
      'Provides academic and career guidance',
      'Offers mentorship and counseling',
      'Supports mental health and well-being',
      'Creates scholarship opportunities',
      'Builds life skills and confidence',
      'Connects students with resources',
    ],
    skillsTitle: 'Support Services',
    skills: [
      { title: 'Academic Support', description: 'Tutoring and study resources for students.' },
      { title: 'Career Guidance', description: 'Help students plan their career paths.' },
      { title: 'Mentorship', description: 'One-on-one guidance from experienced mentors.' },
      { title: 'Scholarships', description: 'Financial aid for deserving students.' },
      { title: 'Counseling', description: 'Mental health and emotional support.' },
      { title: 'Extra-Curricular', description: 'Activities beyond academics.' },
    ],
    cta: 'Learn More',
  },
  spirituality: {
    title: 'Spirituality',
    subtitle: 'Nurturing inner growth, moral values, and cultural consciousness among youth.',
    heroImage: images[1],
    intro: 'Spirituality programs help youth develop inner strength, moral values, and cultural consciousness through meditation, yoga, value education, and spiritual discourse.',
    whyTitle: 'Why Spirituality Matters ?',
    whyItems: [
      'Develops inner peace and strength',
      'Builds moral and ethical values',
      'Promotes cultural consciousness',
      'Encourages mindfulness and reflection',
      'Strengthens character development',
      'Connects youth with Indian philosophy',
    ],
    skillsTitle: 'Programs Offered',
    skills: [
      { title: 'Yoga & Meditation', description: 'Physical and mental wellness practices.' },
      { title: 'Value Education', description: 'Lessons in ethics and moral conduct.' },
      { title: 'Spiritual Discourse', description: 'Talks by spiritual leaders and scholars.' },
      { title: 'Scripture Study', description: 'Understanding Indian spiritual texts.' },
      { title: 'Retreat Programs', description: 'Immersive spiritual experiences.' },
      { title: 'Community Satsang', description: 'Group spiritual gatherings.' },
    ],
    cta: 'Learn More',
  },
  democracy: {
    title: 'Democracy',
    subtitle: 'Encouraging civic responsibility and nation-building participation among youth.',
    heroImage: images[2],
    intro: 'Democracy programs educate youth about civic rights, responsibilities, and active participation in democratic processes for a stronger nation.',
    whyTitle: 'Why Democracy Education Matters ?',
    whyItems: [
      'Builds informed citizens',
      'Encourages voter participation',
      'Promotes civic engagement',
      'Teaches democratic values',
      'Develops critical thinking about governance',
      'Strengthens democratic institutions',
    ],
    skillsTitle: 'Key Programs',
    skills: [
      { title: 'Civic Education', description: 'Understanding democratic rights and duties.' },
      { title: 'Youth Parliament', description: 'Simulated legislative sessions.' },
      { title: 'Voter Awareness', description: 'Importance of electoral participation.' },
      { title: 'Policy Discussions', description: 'Debate on current policy issues.' },
      { title: 'Community Forums', description: 'Local governance engagement.' },
      { title: 'Leadership in Democracy', description: 'Youth roles in democratic processes.' },
    ],
    cta: 'Learn More',
  },
  environment: {
    title: 'Environment',
    subtitle: 'Encouraging environmental awareness and sustainable practices for a better future.',
    heroImage: images[3],
    intro: 'Environmental programs promote awareness and action for sustainability through tree plantation, clean-up drives, and environmental education.',
    whyTitle: 'Why Environment Matters ?',
    whyItems: [
      'Protects natural resources',
      'Promotes sustainable living',
      'Addresses climate change',
      'Engages youth in green initiatives',
      'Creates environmental awareness',
      'Builds eco-conscious communities',
    ],
    skillsTitle: 'Green Initiatives',
    skills: [
      { title: 'Tree Plantation', description: 'Mass plantation drives across communities.' },
      { title: 'Clean-Up Drives', description: 'Beach, river, and park clean-up activities.' },
      { title: 'Waste Management', description: 'Recycling and waste reduction programs.' },
      { title: 'Eco Education', description: 'Workshops on environmental conservation.' },
      { title: 'Green Campus', description: 'Sustainable practices in institutions.' },
      { title: 'Water Conservation', description: 'Rainwater harvesting and water saving.' },
    ],
    cta: 'Learn More',
  },
  health: {
    title: 'Health',
    subtitle: 'Promoting physical, mental, and social well-being for a healthier society.',
    heroImage: images[4],
    intro: 'Health programs focus on physical fitness, mental wellness, and social well-being through camps, workshops, and awareness campaigns.',
    whyTitle: 'Why Health Matters ?',
    whyItems: [
      'Promotes physical fitness',
      'Supports mental wellness',
      'Creates health awareness',
      'Provides free health camps',
      'Encourages healthy lifestyles',
      'Builds healthier communities',
    ],
    skillsTitle: 'Health Programs',
    skills: [
      { title: 'Health Camps', description: 'Free medical check-ups and consultations.' },
      { title: 'Mental Wellness', description: 'Counseling and stress management.' },
      { title: 'Nutrition Education', description: 'Healthy eating and lifestyle habits.' },
      { title: 'Yoga & Fitness', description: 'Physical wellness programs.' },
      { title: 'Health Awareness', description: 'Campaigns on disease prevention.' },
      { title: 'First Aid Training', description: 'Emergency response skills.' },
    ],
    cta: 'Learn More',
  },
  fitness: {
    title: 'Fitness',
    subtitle: 'Building confidence and discipline through fitness and active living.',
    heroImage: images[0],
    intro: 'Fitness programs build physical strength, discipline, and confidence through sports, exercise routines, and active lifestyle promotion.',
    whyTitle: 'Why Fitness Matters ?',
    whyItems: [
      'Builds physical strength and stamina',
      'Develops discipline and routine',
      'Boosts confidence and self-esteem',
      'Promotes team spirit through sports',
      'Encourages active lifestyle',
      'Supports overall well-being',
    ],
    skillsTitle: 'Fitness Activities',
    skills: [
      { title: 'Sports Training', description: 'Cricket, football, athletics, and more.' },
      { title: 'Yoga Sessions', description: 'Flexibility and mindfulness practice.' },
      { title: 'Fitness Challenges', description: 'Community fitness competitions.' },
      { title: 'Marathon Events', description: 'Running events for health awareness.' },
      { title: 'Gym Programs', description: 'Structured workout routines.' },
      { title: 'Adventure Sports', description: 'Trekking, camping, and outdoor activities.' },
    ],
    cta: 'Learn More',
  },
  education: {
    title: 'Education',
    subtitle: 'Empowering youth through education, leadership, and values.',
    heroImage: images[1],
    intro: 'Education programs provide learning opportunities, scholarships, and skill development to empower youth with knowledge and values for success.',
    whyTitle: 'Why Education Matters ?',
    whyItems: [
      'Provides access to quality education',
      'Offers scholarships and financial aid',
      'Develops critical thinking skills',
      'Promotes lifelong learning',
      'Bridges educational gaps',
      'Empowers youth for future success',
    ],
    skillsTitle: 'Educational Programs',
    skills: [
      { title: 'Scholarships', description: 'Financial support for deserving students.' },
      { title: 'Tutoring', description: 'Free academic support and coaching.' },
      { title: 'Digital Literacy', description: 'Computer and technology skills training.' },
      { title: 'Library Programs', description: 'Access to books and learning resources.' },
      { title: 'Career Counseling', description: 'Guidance for educational and career paths.' },
      { title: 'Skill Workshops', description: 'Practical skills beyond academics.' },
    ],
    cta: 'Learn More',
  },
}
